import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {IconButton} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import {cancelOrder, getDoctorOrderedAssayPdf, getDoctorOrderSchedule} from "@cabinet-packages/api/api";
import {addAssayToOrderList, getCatalog, setDoctorOrderedAssays, SET_DOCTOR_ORDERED_ASSAYS} from "@cabinet-packages/redux";
import {Loading} from "@cabinet-packages/components";
import {useHistory} from "react-router-dom";
import * as xlsx from "xlsx";
import moment from "moment";
import ConfirmationDialog from '../../components/ConfirmationDialog';
import PageHeader from '../../components/PageHeader';
import { useNotification } from '../../context/NotificationContext';
import { useStyles } from './styles';

const PartnerOrderedAssays = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const { activePatient } = useSelector(state => state.patients);
    const { doctorOrderedAssays } = useSelector(state => state.orderAssays);
    const { catalog, complexResearch, actions, takeId }  = useSelector(state => state.assaysCatalog);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [expandedRows, setExpandedRows] = useState({});
    const [cancelingIds, setCancelingIds] = useState({});
    const [confirmCancelId, setConfirmCancelId] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const { showSuccess, showError } = useNotification();
    const createAssaysData = (curAssay) => [...catalog, ...complexResearch, ...actions]
        .find(item => +item.id === +curAssay.idPacket && +item.idConf === +curAssay.idConf);

    const handleSetDoctorOrders = async (e) => {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        setLoading(true);

        if (error.length > 0) setError(false);

        try {
            const result = await getDoctorOrderSchedule(activePatient.id)
                .catch(onerror => setError("Вибачте, сталась помилка при завантаженні."));
            dispatch(setDoctorOrderedAssays(result.sort((a, b) => b.id - a.id)));
        } catch (e) {
            console.log(e)
        }
        setLoading(false);
    };

    const handleSendSameOrder = (e, assay) => {
        e.stopPropagation();
        e.preventDefault();

        assay.services.forEach(item => {
            const findAssay = createAssaysData(item);
            if (findAssay && findAssay.idParent !== takeId) {
                dispatch(addAssayToOrderList(
                    findAssay.id,
                    findAssay.discount
                        ? findAssay.price - findAssay.price * findAssay.discount / 100
                        : findAssay.price,
                    ()=>{},
                    findAssay.type,
                ));
            }
        });
        history.push('/order-manager');
    };

    const handleDownloadPdf = async (e, assay) => {
        e.stopPropagation();
        e.preventDefault();

        setLoadingPdf(prevState => ({...prevState, [assay.id]: true}));
        if (error.length > 0) setError('');
        try {
            const todayDate = new Date();
            const createAssays = (ids) => ids.map(currId => (
                [...catalog, ...complexResearch, ...actions]
                    .find(currAssay => +currAssay.id === +currId.idPacket && +currAssay.idConf === +currId.idConf)));
            const res = await getDoctorOrderedAssayPdf(
                assay.fullname,
                assay.idClient,
                assay.id,
                activePatient.id,
                todayDate.toISOString().slice(0, 10),
                createAssays(assay.services).reduce((acu, cur) => {
                    return acu + cur.price;
                }, 0),
                +assay.num,
                createAssays(assay.services).map(item => ({
                    idPacket: item.id,
                    idConf: item.idConf,
                    price: item.price,
                    packetName: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
                    priceDiscount: item.discount ? item.price - item.price * item.discount / 100 : item.price,
                    discount: item.discount ? item.discount : 0,
                    amount: 1,
                    debt: 0,
                    durationDay: item.duration_day ? item.duration_day : 1,
                }))
            );
            const url = window.URL.createObjectURL(new Blob([res], {type: 'application/pdf'}));
            const link = document.createElement('a');
            link.href = url;
            link.download = `${assay.fullname}.pdf`;
            link.click();
            link.remove();
        } catch (e) {
            setError("Вибачте, сталась помилка при завантаженні PDF.")
        }

        setLoadingPdf(prevState => ({...prevState, [assay.id]: false}));
    };

    useEffect(() => {
        if (!doctorOrderedAssays) handleSetDoctorOrders();
        if (!catalog) dispatch(getCatalog());
    }, [doctorOrderedAssays, catalog, dispatch])


    const getRealPrice = (data) => {
        return data.services.reduce((acu, cur) => {
            return acu + cur.real_price
        }, 0);
    }

    const getAssayForExcel = (data) => {
        console.log(data, 'data')
        return data.services.reduce((acu, cur) => {
            return acu + cur.name + "-" + cur.real_price + "/" + cur.price + ";"
        }, "");
    }

    function download(items) {
        const result = [];
        items.forEach((element, idx) => {
            element.services.forEach((service) => {
                result.push(
                    {
                        "Номер": idx+1,
                        'Користувач': element.fullname,
                        'Створено': element.crDate.slice(0, 16),
                        'Дослідження': service.name,
                        'Базова ціна дослідження': service.real_price,
                        'Ціна дослідження': service.price,
                        'Загальна базова ціна замовлення': getRealPrice(element),
                        'Загальна ціна замовлення': element.price,
                    }
                )
            })

        });

        const worksheet = xlsx.utils.json_to_sheet(result)
        const workbook = {
            Sheets: {
                'Дані': worksheet
            },
            SheetNames: ['Дані']
        }
        const exelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'})
        const fileBlob = new Blob([exelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        const dataTime = new Date()
        const url = window.URL.createObjectURL(new Blob([fileBlob], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        const link = document.createElement('a');
        link.href = url;
        link.download = `Дані.${dataTime.getFullYear()}-${+dataTime.getMonth() + 1}-${dataTime.getDate()}.xlsx`;
        link.click();
        link.remove();
    }

    const filteredAssays = useMemo(() => {
        if (!doctorOrderedAssays) return [];

        const search = searchValue.trim().toLowerCase();
        const from = startDate ? moment(startDate).startOf('day') : null;
        const to = endDate ? moment(endDate).endOf('day') : null;

        return doctorOrderedAssays.filter(assay => {
            if (search.length > 0) {
                const idMatch = String(assay.id || '').toLowerCase().includes(search);
                const nameMatch = (assay.fullname || '').toLowerCase().includes(search);
                if (!idMatch && !nameMatch) return false;
            }

            if (from || to) {
                const orderDate = moment(assay.crDate);
                if (!orderDate.isValid()) return false;
                if (from && orderDate.isBefore(from)) return false;
                if (to && orderDate.isAfter(to)) return false;
            }

            return true;
        });
    }, [doctorOrderedAssays, searchValue, startDate, endDate]);

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    };

    const handleDateRangeChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    };

    const handleDownloadExcel = () => {
        download(filteredAssays.filter(assay => assay.idOrder !== -1));
    };

    const formatDate = (dateStr, withTime = false) => {
        if (!dateStr || dateStr === 'null') return null;
        const m = moment(dateStr);
        if (!m.isValid()) return null;
        return m.format(withTime ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY');
    };

    const toggleRow = (id, hasNote) => {
        if (window.innerWidth > 600 && !hasNote) return;
        setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const handleCancelClick = (e, id) => {
        e.stopPropagation();
        e.preventDefault();
        setConfirmCancelId(id);
    };

    const handleConfirmCancel = async () => {
        const id = confirmCancelId;
        if (!id) return;
        setCancelingIds(prev => ({ ...prev, [id]: true }));
        try {
            await cancelOrder(id);
            showSuccess('Замовлення успішно скасовано');
            const result = await getDoctorOrderSchedule(activePatient.id);
            if (result) {
                dispatch({
                    type: SET_DOCTOR_ORDERED_ASSAYS,
                    payload: { orderedAssays: result.sort((a, b) => b.id - a.id) },
                });
            }
        } catch (err) {
            showError('Помилка при скасуванні замовлення');
        } finally {
            setCancelingIds(prev => {
                const next = { ...prev };
                delete next[id];
                return next;
            });
        }
    };

    const hasOrders = doctorOrderedAssays && doctorOrderedAssays.length > 0;
    const hasFilteredData = filteredAssays.length > 0;
    const isFiltering = searchValue.trim().length > 0 || startDate || endDate;

    return (
        <div className={classes.root}>
            <PageHeader
                title="Призначені дослідження"
                searchInput={{
                    value: searchValue,
                    onChange: handleSearchChange,
                    placeholder: "Пошук за номером або ПІБ"
                }}
                dateRangePicker={{
                    initialStartDate: startDate,
                    initialEndDate: endDate,
                    onChange: handleDateRangeChange,
                    disableFuture: true,
                    placeholder: "Оберіть діапазон дат"
                }}
                iconButton={hasFilteredData ? {
                    onClick: handleDownloadExcel,
                    icon: <GetAppIcon />,
                    ariaLabel: "Завантажити в Excel",
                    tooltip: "Завантажити в Excel"
                } : null}
            />

            {error.length !== 0 && <p className={classes.dialogErrorText}>{error}</p>}

            {loading
                ? <Loading/>
                : <div className={classes.scrollWrapper}>
                    <div className={classes.scrollContent}>
                        {hasFilteredData ? (
                            <div className={classes.tableContainer}>
                                <table className={classes.table}>
                                    <thead className={classes.tableHead}>
                                        <tr>
                                            <th className={classes.thUserData}>Дані користувача</th>
                                            <th className={classes.thResearch}>Замовлені дослідження</th>
                                            <th className={classes.thPrice}></th>
                                            <th className={classes.thTotal}>Ціна базова, грн</th>
                                            <th className={classes.thAction}></th>
                                            <th className={classes.chevronCellHead}></th>
                                        </tr>
                                    </thead>
                                    <tbody className={classes.tableBody}>
                                        {filteredAssays.map(assay => {
                                            const hasNote = assay.note && assay.note.trim().length > 0;
                                            return (
                                            <React.Fragment key={assay.id}>
                                                <tr className={`${classes.mobileRow} ${hasNote ? classes.rowWithNote : ''} ${expandedRows[assay.id] ? classes.mobileRowExpanded : ''}`} onClick={() => toggleRow(assay.id, hasNote)}>
                                                    <td className={classes.userDataCell}>
                                                        <p>
                                                            <span className={classes.userDataLabel}>№:</span> {assay.id}
                                                        </p>
                                                        <p>
                                                            <span className={classes.userDataLabel}>ПІБ:</span> {assay.fullname}
                                                        </p>
                                                        <p>
                                                            <span className={classes.userDataLabel}>Створено:</span> {formatDate(assay.crDate, true)}
                                                        </p>
                                                        {formatDate(assay.dateValid) && (
                                                            <p>
                                                                <span className={classes.userDataLabel}>Дійсне до:</span> {formatDate(assay.dateValid)}
                                                            </p>
                                                        )}
                                                        {formatDate(assay.dateVisit) && (
                                                            <p>
                                                                <span className={classes.userDataLabel}>Зареєстровано:</span> {formatDate(assay.dateVisit)}
                                                            </p>
                                                        )}
                                                    </td>
                                                    {assay.idOrder === -1 ? (
                                                        <td colSpan={4} className={classes.cancelledCell}>
                                                            <p className={classes.cancelledText}>Скасовано</p>
                                                        </td>
                                                    ) : (
                                                        <>
                                                            <td className={classes.researchCell}>
                                                                {assay.services.map((service, idx) => (
                                                                    <div key={service.idPacket} className={classes.serviceRow}>
                                                                        <p>{idx + 1}. {service.name}</p>
                                                                    </div>
                                                                ))}
                                                            </td>
                                                            <td className={classes.priceCell}>
                                                                {assay.services.map((service) => (
                                                                    <p key={service.idPacket}>{service.price}</p>
                                                                ))}
                                                            </td>
                                                            <td className={classes.totalPriceCell}>
                                                                <p>{assay.price}</p>
                                                            </td>
                                                            <td className={classes.actionCell} onClick={(e) => e.stopPropagation()}>
                                                                {assay.idOrder === 0 && (
                                                                    <IconButton
                                                                        className={classes.deleteButton}
                                                                        onClick={(e) => handleCancelClick(e, assay.id)}
                                                                        disabled={!!cancelingIds[assay.id]}
                                                                        size="small"
                                                                    >
                                                                        <DeleteIcon className={classes.deleteIcon} />
                                                                    </IconButton>
                                                                )}
                                                            </td>
                                                        </>
                                                    )}
                                                    <td className={classes.chevronCell}>
                                                        <span className={`${classes.chevron} ${expandedRows[assay.id] ? classes.chevronOpen : ''} ${!hasNote ? classes.chevronDesktopHidden : ''}`} />
                                                    </td>
                                                </tr>
                                                <tr className={`${classes.accordionRow} ${!expandedRows[assay.id] ? classes.accordionHidden : ''}`}>
                                                    <td colSpan={6} className={classes.accordionContent}>
                                                        <div className={classes.accordionServicesSection}>
                                                            <p className={classes.accordionTitle}>Замовлені дослідження</p>
                                                            {assay.services.map((service, idx) => (
                                                                <div key={service.idPacket} className={classes.accordionServiceRow}>
                                                                    <p>{idx + 1}. {service.name}</p>
                                                                    <p className={classes.accordionServicePrice}>{service.price}</p>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {hasNote && (
                                                            <div className={classes.noteSection}>
                                                                <p className={classes.accordionTitle}>Примітки</p>
                                                                <p className={classes.noteText}>{assay.note}</p>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className={classes.emptyStateWrapper}>
                                {hasOrders && isFiltering ? (
                                    <>
                                        <h3 className={classes.emptyStateTitle}>Пошук не дав результатів</h3>
                                        <p className={classes.emptyStateSubtitle}>Спробуйте змінити запит або діапазон дат</p>
                                    </>
                                ) : (
                                    <h3 className={classes.emptyStateTitle}>Немає призначених досліджень</h3>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            }

            <ConfirmationDialog
                open={Boolean(confirmCancelId)}
                onClose={() => setConfirmCancelId(null)}
                onConfirm={handleConfirmCancel}
                title="Скасувати замовлення?"
                text={confirmCancelId ? `Ви впевнені, що хочете скасувати замовлення №${confirmCancelId}?` : ''}
                confirmText="Так"
                cancelText="Ні"
                confirmVariant="dangerFilled"
            />
        </div>
    );
};

export default PartnerOrderedAssays;
